// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"36d49c59","457":"8ba966ac","838":"10cf8f42"}[chunkId] + ".chunk.js";
};